import getters from './getters';
import mutations from './mutations';
import actions from './actions';

const defaultState = () => ({
  currentSectionId: 'brandingSettings',
  currentModuleId: 'themebase',
  brandingSettings: {},
  changesMadeInEvent: {},
  changesMadeInThemeObj: {},
  updateBrandingLoading: false,
  updateBrandingError: null,
  completedModules: [],
  currentView: 'monitor',
  monitorStyles: '',
  cellphoneStyles: '',
  switchingViews: false,
  currentTab: 'splash',
  isCurrentModuleInValid: false,
  /**
   * @type {'event' | 'template'}
   */
  for: 'event',
  generatedThemes: [],
  previousBrandingState: null,
  selectedThemeIndex: -1,
  aiThemeGenerationInProgress: false,
  showAILookAndFeelSurvey: false,
  aiThemeGenerationTaskId: null
});

const state = defaultState();

export default {
  getters,
  actions,
  mutations,
  state,
  namespaced: true
};
